import { render, staticRenderFns } from "./OrgLabManageIcon.vue?vue&type=template&id=0c387227"
import script from "./OrgLabManageIcon.vue?vue&type=script&lang=js"
export * from "./OrgLabManageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports